import React from 'react';

export const EcranChargement: React.FC<{
  message: string;
}> = ({ message }) => {

  return <div id="ecran-chargement">
    <div className="message">
      {message}
      <div className="loading"></div>
    </div>
  </div>
}